import cms from 'apis/cms';
import { ImgRespProps } from 'types/ImgRespProps';

export async function saveImg(img: any): Promise<ImgRespProps | null> {
  let respImg: null | ImgRespProps = null;
  const dados = new FormData();
  dados.append('file', img);

  await cms.rest
    .post('upload', dados)
    .then((res: any) => {
      if (res.data) {
        respImg = res.data;
      }
    })
    .catch(() => {});

  return respImg;
}
